import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m18 16 4-4-4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6 8-4 4 4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14.5 4-5 16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Code2";
const Code2 = memo(themed(Icon));
export {
  Code2
};
//# sourceMappingURL=code-2.js.map
